export default __webpack_public_path__ + "static/media/moderate-politics-logo.7bfcdd1a.png";